import React, { useEffect, useState } from 'react';

export default function IdpFormManager({ initial = {}, onSubmit, onCancel, submitting = false }) {
    const [form, setForm] = useState({
        manager_support: '',
        date_of_next_meeting: '',
        ...initial,
    });

    useEffect(() => { setForm(prev => ({ ...prev, ...initial })); }, [initial]);

    const change = e => setForm({ ...form, [e.target.name]: e.target.value });

    const submit = e => {
        e.preventDefault();
        onSubmit?.(form);
    };

    return (
        <form onSubmit={submit}>
            <div className="mb-3">
                <label className="form-label">Manager Support</label>
                <textarea className="form-control" rows="3" name="manager_support" value={form.manager_support || ''} onChange={change} />
            </div>

            <div className="mb-3">
                <label className="form-label">Date of Next Meeting</label>
                <input type="date" className="form-control" name="date_of_next_meeting" value={form.date_of_next_meeting || ''} onChange={change} />
            </div>

            <div className="d-flex gap-2">
                <button className="btn btn-primary" type="submit" disabled={submitting}>
                    {submitting ? 'Saving…' : 'Save'}
                </button>
                <button className="btn btn-outline-secondary" type="button" onClick={onCancel}>Cancel</button>
            </div>
        </form>
    );
}
